module.exports = __webpack_public_path__ + "static/media/pawprint (1).c63b6069.png";